var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "ml-2",
                    attrs: { icon: "", "x-small": "" },
                    on: {
                      click: function ($event) {
                        return _vm.toWiki(_vm.section)
                      },
                    },
                  },
                  on
                ),
                [_c("v-icon", [_vm._v("help_outline")])],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "span",
        [
          _vm._v(" Go to wiki... "),
          _c("v-icon", { attrs: { small: "", dark: "" } }, [
            _vm._v("open_in_new"),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }